import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';

const GRANTS = 'grants';

const returnResponse = response => {
  const json = response.json();
  if (!response.ok)
    return json.then(error => {throw error});
  return json;
};

export default class GrantsService {
  static findAllGrants(localAuthorityId) {
    return fetch(`${apiBaseUrl}/${GRANTS}/${localAuthorityId}`, {headers: getBaseHeader()})
      .then(returnResponse);
  }

  static createGrant(grant) {
    const body = JSON.stringify({grant: grant});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };
    const method = 'POST';

    return fetch(`${apiBaseUrl}/${GRANTS}`, {body, headers, method})
      .then(returnResponse);
  }

  static findGrantById(grantId) {
    return fetch(`${apiBaseUrl}/${GRANTS}/${grantId}`, {headers: getBaseHeader()})
      .then(returnResponse);
  }
}



// WEBPACK FOOTER //
// ./src/service/sfp/grant-service.js